import classNames from 'classnames';
import { ReactNode } from 'react';

import BrandIcon from '../icons/BrandIcon';
import DocumentTypeIcon from '../icons/DocumentTypeIcon';
import Blocked from './Blocked';
import Image, { ImageProps } from './Image';

import styles from '../../styles/partials/document-image.module.css';

export interface DocumentImageProps extends ImageProps {
    type?: DocumentTypeString | 'comment' | null;
    blocked?: boolean;
    unblocked?: boolean;
    progress?: number | null;
    brand?: BrandHandle | null;
    withIcon?: boolean;
    withoutTypeIcon?: boolean;
    withBrandIcon?: boolean;
    withoutBlockedIcon?: boolean;
    children?: ReactNode;
    className?: string | null;
    iconClassName?: string | null;
    typeIconClassName?: string | null;
    blockedIconClassName?: string | null;
    brandIconClassName?: string | null;
}

const DocumentImage = ({
    type = null,
    blocked = false,
    unblocked = false,
    progress = null,
    brand = null,
    withIcon = false,
    withoutTypeIcon = false,
    withBrandIcon = false,
    withoutBlockedIcon = false,
    children = null,
    className = null,
    iconClassName = null,
    blockedIconClassName = null,
    typeIconClassName = null,
    brandIconClassName = null,
    ...props
}: DocumentImageProps) => {
    return (
        <Image className={classNames([styles.container, className])} loading="lazy" {...props}>
            {withIcon && blocked && !withoutBlockedIcon ? (
                <Blocked
                    short
                    unblocked={unblocked}
                    className={classNames([styles.blockedIcon, blockedIconClassName])}
                />
            ) : withIcon && type !== null && !withoutTypeIcon ? (
                <DocumentTypeIcon
                    type={type}
                    className={classNames([
                        styles.icon,
                        styles.typeIcon,
                        iconClassName,
                        typeIconClassName,
                    ])}
                />
            ) : null}
            {withIcon && withBrandIcon && brand !== null ? (
                <BrandIcon
                    type={brand}
                    className={classNames([
                        styles.icon,
                        styles.brandIcon,
                        iconClassName,
                        brandIconClassName,
                    ])}
                />
            ) : null}
            {progress !== null && progress > 0 && (type === 'video' || type === 'podcast') ? (
                <div className={styles.progress} style={{ width: `${progress * 100}%` }} />
            ) : null}
            {children}
        </Image>
    );
};

export default DocumentImage;
